import { VegaChartMasterColor } from '@asset-metrix/portal-gateway-client-js';

import { usePortalTheme } from '../../app/usePortalTheme';

export type ChartColor = string;

type VegaChartTenantAgnosticColors = {
  textColor: ChartColor;
};

const vegaChartLightScheme: VegaChartTenantAgnosticColors = {
  textColor: 'rgb(7, 23, 32)',
};

const vegaChartDarkScheme: VegaChartTenantAgnosticColors = {
  textColor: 'rgb(235, 240, 241)',
};

type SchemeColors = {
  primaryColor: ChartColor;
  secondaryColor: ChartColor;
  textColor: ChartColor;
  masterColors: VegaChartMasterColor[];
};

export function useVegaSchemeColors(): SchemeColors {
  const { activeTheme: tenantThemeVariables, colorScheme } = usePortalTheme();

  const { textColor } =
    colorScheme === 'light' ? vegaChartLightScheme : vegaChartDarkScheme;

  const primaryColorVariable =
    tenantThemeVariables?.['--portal-ui-color-primary'];

  const secondaryColorVariable =
    tenantThemeVariables?.['--portal-ui-color-secondary'];

  const masterColors =
    colorScheme === 'light' || colorScheme === 'dark'
      ? (tenantThemeVariables?.['vega-chart-master-color'] ?? [])
      : [];

  return {
    textColor,
    primaryColor:
      primaryColorVariable != null ? `rgb(${primaryColorVariable})` : textColor,
    secondaryColor:
      secondaryColorVariable != null
        ? `rgb(${secondaryColorVariable})`
        : textColor,
    masterColors,
  };
}
